import React, { useState } from 'react';
import { MdModeEditOutline } from 'react-icons/md';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import ContainerTitle from '../shared/container/ContainerTitle';
import UpdateVehicleModal from './modals/UpdateVehicleModal';

const VehiclesHeader = ({ readOnly, refresh }) => {
  const [showUpdateVehicleModal, setShowUpdateVehicleModal] = useState(false);

  const handleVehicleModalSubmit = async () => {
    refresh();
    setShowUpdateVehicleModal(false);
  };

  return (
    <ContainerHeader>
      {showUpdateVehicleModal && (
        <UpdateVehicleModal
          onModalSubmit={() => handleVehicleModalSubmit()}
          onModalClose={() => setShowUpdateVehicleModal(false)}
        />
      )}
      <ContainerTitle title={'Загальна інформація'} />
      {!readOnly && (
        <Button variant={'primary'} onClick={() => setShowUpdateVehicleModal(true)}>
          <MdModeEditOutline />
          Редагувати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default VehiclesHeader;
